import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import FastqFileType from 'const/enums/FastqFileType';
var rReadRegex = /_R([12])/;
var underscoreReadRegex = /_([12])\.(fastq|fq)\.gz$/;
var getPairData = function getPairData(fileName) {
  var _name$match;
  var name = fileName;
  var rReadMatch = (_name$match = name.match(rReadRegex)) !== null && _name$match !== void 0 ? _name$match : name.match(underscoreReadRegex);
  var _rReadMatch = _slicedToArray(rReadMatch, 2),
    readNumberStr = _rReadMatch[1];
  name = name.replace(rReadRegex, '');
  name = name.replace(underscoreReadRegex, '');
  name = name.replace(/\.(fastq|fq)\.gz$/, '');
  return {
    name: name,
    readNumber: parseInt(readNumberStr, 10)
  };
};
var getMatchingPairFor = function getMatchingPairFor(fileName) {
  var matcher = fileName.match(rReadRegex) ? rReadRegex : underscoreReadRegex;
  var matchingPair = fileName.replace(matcher, function (match, group1) {
    var otherNumber = group1 === '1' ? '2' : '1';
    return match.replace(group1, otherNumber);
  });
  return matchingPair;
};
var hasReadPair = function hasReadPair(fileName) {
  return rReadRegex.test(fileName) || underscoreReadRegex.test(fileName);
};

// This function assumes that the files are already paired correctly,
// no checks are done on that end
var getPairsForFiles = function getPairsForFiles(files) {
  var sublibraries = _defineProperty(_defineProperty({}, FastqFileType.IMMUNE_FASTQ, {}), FastqFileType.WT_FASTQ, {});
  Object.values(files).forEach(function (file) {
    var _sublibraries$file$ty, _sublibraries$file$ty2;
    if (file.type === 'samplelt') return;
    var _getPairData = getPairData(file.name),
      pairName = _getPairData.name,
      readNumber = _getPairData.readNumber;
    var pairData = (_sublibraries$file$ty2 = (_sublibraries$file$ty = sublibraries[file.type])[pairName]) !== null && _sublibraries$file$ty2 !== void 0 ? _sublibraries$file$ty2 : _sublibraries$file$ty[pairName] = [];

    // reads are 1 or 2, we want to store them in the array at index 0 or 1
    pairData[readNumber - 1] = file.id;
  });

  // Validate that every array in sublibraries' values has length 2
  Object.values(sublibraries).forEach(function (typeObj) {
    Object.values(typeObj).forEach(function (filesArr) {
      if (filesArr.length !== 2 || filesArr.includes(undefined)) {
        throw new Error('Invalid number of files per sulibrary');
      }
    });
  });
  return sublibraries;
};
export { getPairsForFiles, getMatchingPairFor, hasReadPair, getPairData };